<template>
    <div>
        <div class="user_right">
            <h1 class="urs_h1">我的积分</h1>
            <div class="lh30 f16">
                <p>我的等级：{{grade.rating==1 && grade.coin_rating>1?grade.coin_rating_cn:grade.rating_cn}}，<em class="i_new f12">手机已验证</em></p>
                <p>剩余积分：<b class="c3">{{$fnc.toFixedZ(grade.integral,2) }}</b></p>
                <p class="lh30">&nbsp;</p>
            </div>
            <h2 class="urs_h1">积分记录</h2>
            <table width="100%" border="0" class="u_otb mt15">
                <tbody>
                    <tr>
                        <th>订单</th>
                        <th>类型</th>
                        <th>剩余</th>
                        <th>添加积分</th>
                        <th>获取时间</th>
                    </tr>
                    <tr v-for="(item,index) in tableData.data" :key="index">
                        <td>{{item.oid}}</td>
                        <td>{{item.style}}</td>
                        <td>{{' '+$fnc.toFixedZ(item.balance,3)}}</td>
                        <td v-if="item.types == 1">+{{$fnc.toFixedZ(item.money,3)}}</td>
                        <td v-if="item.types == 2">-{{$fnc.toFixedZ(item.money,3)}}</td>
                        <td>{{' '+$fnc.getTimeFormat(item.created_time)}}</td>
                    </tr>
    	        </tbody>
	        </table>
            <div class="page" id="pager">
                <el-pagination :page-sizes="[12,24,36,48]" :page-size="tableFrom.limit" :current-page="tableFrom.page" layout="total, sizes, prev, pager, next, jumper" :total="tableData.total" @size-change="handleSizeChange" @current-change="pageChange" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            grade:[],
            list:[],
            iden:"integral",
            is_friend: 0,
            status:0,
            tableData: {
                data: [],
                total: 0,
            },
            listLoading: true,
            LogLoading: false,
            dialogVisible: false,

            tableFrom: {
                page: 1,
                page_size: 10,
                id:JSON.parse(window.localStorage.getItem("user")).id ? JSON.parse(window.localStorage.getItem("user")).id : "",
            },
        }
    },
    mounted(){
        this.grade = JSON.parse(window.localStorage.getItem("user"));
        this.getGrade();
        this.getList(1);
    },
    methods:{
        getGrade(){
            var params = {};
            params.id = JSON.parse(window.localStorage.getItem("user")).id ||"";
            params.iden = this.iden ||"";
            this.$api.getUser.getGrade(params).then(res=>{
                this.tableData.data = res.result.data;
                this.tableData.total = res.result.counts;  // 总条目数
                this.tableData.page = res.result.page;
                this.tableData.page_size = res.result.pageSize;
                this.listLoading = false;
            })
        },
        //列表
        getList(num) {
            this.listLoading = true;
            this.tableFrom.page = num ? num : this.tableFrom.page;
            this.$api.getUser.getGrade(this.tableFrom).then((res) => {
                if (res.code == 200) {
                    this.tableData.data = res.result.data;
                    this.tableData.total = res.result.counts;  // 总条目数
                    this.tableData.page = res.result.page;
                    this.tableData.page_size = res.result.pageSize;
                    this.tableData.id = JSON.parse(window.localStorage.getItem("user")).id;
                    this.listLoading = false;
                }
            }).catch((res) => {
                this.$message.error(res.message);
                this.listLoading = false;
            });
        },
        pageChange(page) {
            this.tableFrom.page = page;
            this.getList('');
        },
        handleSizeChange(val) {
            this.tableFrom.limit = val;
            this.getList('');
        },
    }
}
</script>

<style scoped>
@import url('../../assets/css/user.css');
</style>


// WEBPACK FOOTER //
// src/components/grade/Index.vue